import { defineStore } from 'pinia';
import { ref } from 'vue'


export const useRefreshStore = defineStore('refresh', () => {
    const refreshRegister = ref(false)
    const refreshExecution = ref(false)
    const refreshExport = ref(false)
    const setRefreshRegister = (value) => {
        refreshRegister.value = value
    }
    const setRefreshExecution = (value) => {
        refreshExecution.value = value

    }
    const setRefreshExport = (value) => {
        refreshExport.value = value

    }
    return { refreshRegister, refreshExecution, refreshExport, setRefreshRegister, setRefreshExecution, setRefreshExport };
});
